import React from 'react';

export const squarePath = 'M9 9h47v47H9z';
export default class Square extends React.PureComponent {
  render() {
    return <path d={squarePath} className="fill-current" />;
  }
}
